
<div class="card">
  <div class="card-header card-header-grey">
    <h4 class="card-title ">
      Connexion
    </h4>
  </div>
 


  <div class="container-fluid">
    <div *ngIf="errorLogin" class="row" style="margin: 1rem;">
      <div class="col-12 text-rose text-center">
        <strong>
          Identifiant ou Mot de passe incorrect.
          Veuillez essayer de nouveau ou réinitialiser votre mot de passe.
        </strong>
      </div>
    </div>
    <div class="row" style="margin-top: 1rem;">
      <div class="col-md-3 offset-md-3">
        <p>
          <mat-form-field [color]="param.color" appearance="legacy">
            <mat-label>Identifiant / Adresse email</mat-label>
            <input matInput [(ngModel)]='identifiant' required />
          </mat-form-field>
        </p>
      </div>
      <div class="col-md-3">
        <p>
          <mat-form-field [color]="param.color" appearance="legacy">
            <mat-label>Mot de passe</mat-label>
            <input tabindex="0" type="password" matInput [(ngModel)]='pass' required />
          </mat-form-field>
        </p>
      </div>
    </div>
    <div style="text-align: center;">
      <p>
        <button tabindex="0" [disabled]="loading || (!identifiant || !pass)" mat-flat-button (click)="onSubmit()" class="center" [color]="param.color">
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
          Valider
        </button>
      </p>
      <p class="accent">
        <a tabindex="0" href="/lost-pass">{{ config('mot_de_passe_perdu')?.txt }}</a>
      </p>
    </div>
  </div>
</div>
